import React, {useEffect, useContext, useState} from 'react';
import {NavLink, useLocation, useNavigate} from 'react-router-dom';

import styles from './CheckoutResult.module.scss';
import successImg from '../../assets/images/success.png';
import errorImg from '../../assets/images/error.png';

import {ERROR_MAINTENANCE, SUPPORT_MAIL} from "../../shared/constants";
import { withResponseHandling } from "../../shared/responseHandler";
import ButtonNew from "../../components/buttons/ButtonNew/ButtonNew";
import ContextMenuMobile from "../../components/ContextMenu/ContextMenuMobile";
import { request } from '../../shared/request';
import { MilestonesContext } from '../../App';

const CheckoutResult = ({ config, windowSize }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const availableMilestones = useContext(MilestonesContext);

    // Snapshot the result on first render and render from that, never from the
    // live location. "Back To Shop" navigates with state {refreshShop:true}, and
    // the route exit animation keeps this page mounted while it fades out - so
    // reading live state flipped the success view to the "There was an error
    // while processing your order." view for the length of the transition.
    // The fallback also stops a direct visit (no state) from throwing.
    const [result] = useState(() => state || {});

    const goBackToShop = () => {
        localStorage.removeItem('selectedOffer');
        navigate('/shop', {
            state: { refreshShop: true }
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);

        const checkForMilestonesToClaim = async () => {
            let player = localStorage.getItem('playerInfo');
            player = JSON.parse(player);
            
            await withResponseHandling(
                () => request.post(`checkForMilestonesToClaim/${player.id}`),
                {
                    navigate,
                    onSuccess: (response) => {
                        if (response && response.hasMilestoneToClaim) {
                            availableMilestones.setHasAvailableMilestones(true);
                        }
                    },
                }
            );
        }

        checkForMilestonesToClaim();
    }, []);

    return (
        <>
            <ContextMenuMobile windowSize={windowSize} config={config}  />
            <div className={styles.backgroundAddOn}>
                <div className={styles.wrapper}>
                    <div className={styles.result}>
                        <img className={styles.img} src={result.success ? successImg : errorImg} alt={''} />
                        <div className={styles.info}>
                            {result.success ?
                                <div className={styles.resultInfo}>
                                    <div className={styles.title}>
                                        {result.isFreeOffer ? config.freeOffersCheckout.successTitle : config.checkoutResult.successTitle}
                                    </div>
                                    <div className={styles.text}>
                                        <p>
                                            {result.isFreeOffer
                                            ? null
                                            : result.isEventPass
                                                ? config.checkoutResult.eventPassSuccessInfo
                                                : config.checkoutResult.successInfo}
                                        </p>
                                    </div>
                                </div>
                            :
                                <div className={styles.resultInfo}>
                                    <div className={styles.title}>
                                        {result.isFreeOffer ? config.errors.WENT_WRONG : config.checkoutResult.errorTitle}
                                    </div>
                                    <div className={styles.text}>
                                        <p>
                                            {result.isFreeOffer ? null : config.checkoutResult.errorInfo}
                                        </p>
                                        <p><a href={`mailto:${SUPPORT_MAIL}`}>{SUPPORT_MAIL}.</a></p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className={styles.backToShop}>
                        <div>
                            <ButtonNew text={config.backToShop} onClick={goBackToShop} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default CheckoutResult;